import { useContext, useState } from 'react'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { useRestApi } from '../../../lib/RestApi/useRestApi'
import { API_URL } from '../../../shared/actions'

export const useTrainingCategory = () => {
  const [trainingCategory, setTrainingCategory] = useState(false)
  const { deleteNewTrainingCategory, getNewTrainingCategory } = useContext(OtherContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'Training Category', 'ALL_TRAININGCATEGORY', 'GET_ALL_TRAININGCATEGORY')
  const {
    TRAININGCATEGORY: { GET_ALL_TRAININGCATEGORY, ADD_TRAININGCATEGORY, EDIT_TRAININGCATEGORY, DELETE_MANY_TRAININGCATEGORY },
  } = API_URL

  const getAllTrainingCategories = async (dto = {}) => {
    GET_ALL(GET_ALL_TRAININGCATEGORY, setPaginate, getNewTrainingCategory, dto)
  }

  const addTrainingCategory = (dto) => {
    ADD(ADD_TRAININGCATEGORY, dto)
  }

  const updateTrainingCategory = (dto) => {
    UPDATE(EDIT_TRAININGCATEGORY, dto)
  }

  const getTrainingCategory = (dto) => {
    GET_SINGLE_DATA('GET_TRAININGCATEGORY', setTrainingCategory, dto._id)
  }

  const deleteManyTrainingCategory = (dto, setSelected = () => {}) => {
    DELETE(DELETE_MANY_TRAININGCATEGORY, dto, 'trainingCategoryId', setSelected, deleteNewTrainingCategory, 'GET_ALL_TRAININGCATEGORY')
  }

  return {
    addTrainingCategory,
    getAllTrainingCategories,
    getTrainingCategory,
    trainingCategory,
    updateTrainingCategory,
    deleteManyTrainingCategory,
    loading,
    paginate,
  }
}
